import type { Router, RouteRecordRaw } from 'vue-router';

import { usePermissionStoreWithOut } from '/@/store/modules/permission';

import { PageEnum } from '/@/enums/pageEnum';
import { useUserStoreWithOut } from '/@/store/modules/user';

import { PAGE_NOT_FOUND_ROUTE } from '/@/router/routes/basic';
import { getRequest, getlogutUrl } from './geturlGuard';
import { RootRoute } from '/@/router/routes';
import { useMessage } from '/@/hooks/web/useMessage';
import { useRouter } from 'vue-router';
import { router } from '/@/router';
const LOGIN_PATH = PageEnum.BASE_LOGIN;
const ROOT_PATH = RootRoute.path;
const whitePathList: PageEnum[] = [LOGIN_PATH];

export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut();
  const permissionStore = usePermissionStoreWithOut();
  router.beforeEach(async (to, from, next) => {
    if (
      from.path === ROOT_PATH &&
      to.path === PageEnum.BASE_HOME &&
      userStore.getUserInfo.homePath &&
      userStore.getUserInfo.homePath !== PageEnum.BASE_HOME
    ) {
      next(userStore.getUserInfo.homePath);
      return;
    }
    const routers = useRouter();
    const token = userStore.getToken;
    const geturl = getRequest('app_id', 'url');
    const get_logUrl:any = getlogutUrl('url');
    const get_state:any = getlogutUrl('state');
    const get_token:any = getlogutUrl('token');
    const gtesign:any = getRequest('sign', 'account');
    // Whitelist can be directly entered
    const routlist = userStore.getRoutList;
    if (whitePathList.includes(to.path as PageEnum)) {
      if (to.path === LOGIN_PATH && token) {
        const isSessionTimeout = userStore.getSessionTimeout;
        try {
          await userStore.afterLoginAction();
          if (!isSessionTimeout) {
            next((to.query?.redirect as string) || '/');
            return;
          }
        } catch {}
      } else {
        //判断有没有token值
        // const { createMessage } = useMessage();
        if (get_state !== undefined && Number(get_state.state) === 0 && get_state.token !== '') {
          userStore.SetLogincode(0);
          const url = decodeURIComponent(get_state.redirect_uri);
          const newUrl =
            url.includes('#/login') == true ? url.replace('#/login', '') : url.replace('#/', '');
          //if(newUrl === 'internal://login'){
          if (newUrl.indexOf('//login') !== -1) {
            // console.log(newUrl,'newUrlnewUrl');
            userStore.setToken(get_state.token);
            window.parent.postMessage({ cmd: 'login-token', token: get_state.token }, '*');
          } else {
            if (window.location.origin === newUrl) {
              window.parent.postMessage(
                { cmd: 'readline-link', token: get_state.token, url: newUrl },
                '*',
              );
            } else {
              //window.location.href = newUrl+"/?token=" +  get_state.token
              window.parent.postMessage(
                { cmd: 'noreadline-link', token: get_state.token, url: newUrl },
                '*',
              );
            }
          }
          //console.log(newUrl+ "?token=" + get_state.token, 'newUrl');
        } else if (get_token !== undefined && get_token.token !== '') {
          const use_get_token = get_token.token.split('#');
          const use_token = use_get_token[0];
          userStore.setToken(use_token);
          userStore.setRoutePage('/index');
          window.location.href = '/#/index';
        }
      }
      next();
      return;
    }
    if (get_state !== undefined && get_state.state !== '0') {
      userStore.SetLogincode(get_state.state);
      if (get_state.ext !== undefined) {
        userStore.SetLoginmsg(decodeURIComponent(get_state.ext));
      } else {
        userStore.SetLoginmsg(decodeURIComponent(get_state.ext + get_state.msg));
      }
      next({ path: '/login' });
    }

    // if (geturl !== undefined) {
    //  //window.location.href= geturl.url;
    // }
    if (gtesign !== undefined) {
      await userStore.GetautoLoginAction(gtesign);
    }

    // token does not exist
    if (!token) {
      // You can access without permission. You need to set the routing meta.ignoreAuth to true
      if (to.meta.ignoreAuth) {
        next();
        return;
      }

      // redirect login page
      const redirectData: { path: string; replace: boolean; query?: Recordable<string> } = {
        path: LOGIN_PATH,
        replace: true,
      };
   
      if (get_logUrl !== undefined) {
        var matched = get_logUrl.url.match(/(https?:\/\/[^/]+)/);
        redirectData.query = {
          url: matched[1],
        };
      } else {
        if (to.path) {
          redirectData.query = {
            ...redirectData.query,
            redirect: to.path,
          };
        }
      }
      next(redirectData);
      return;
    } else {
      if (get_logUrl !== undefined) {
        await userStore.getVerificationToken();
        //window.location.href = get_logUrl.url + "/?token=" + token;
      }
    }
    // Jump to the 404 page after processing the login
    if (
      from.path === LOGIN_PATH &&
      to.name === PAGE_NOT_FOUND_ROUTE.name &&
      to.fullPath !== (userStore.getUserInfo.homePath || PageEnum.BASE_HOME)
    ) {
      next(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
      return;
    }
    // get userinfo while last fetch time is empty
    if (userStore.getLastUpdateTime === 0) {
      try {
        await userStore.getUserInfoAction();
        //await userStore.getUserUrl();
      } catch (err) {
        next();
        return;
      }
    }

    if (permissionStore.getIsDynamicAddedRoute) {
      next();
      return;
    }

    const routes = await permissionStore.buildRoutesAction();

    routes.forEach((route) => {
      router.addRoute(route as unknown as RouteRecordRaw);
    });

    router.addRoute(PAGE_NOT_FOUND_ROUTE as unknown as RouteRecordRaw);

    permissionStore.setDynamicAddedRoute(true);

    if (to.name === PAGE_NOT_FOUND_ROUTE.name) {
      // 动态添加路由后，此处应当重定向到fullPath，否则会加载404页面内容
      //判断路由后台地址是否，没有的返回首页
      if (routlist.length === 0) {
        if (to.name === PAGE_NOT_FOUND_ROUTE.name) {
          if (get_token !== undefined && get_token.token !== '') {
            next({ path: '/index' });
          } else {
            next({ path: to.fullPath, replace: true, query: to.query });
          }
        } else {
          next({ path: to.fullPath, replace: true, query: to.query });
        }
      } else {
        next({ path: to.fullPath, replace: true, query: to.query });
      }
    } else {
      const redirectPath = (from.query.redirect || to.path) as string;
      const redirect = decodeURIComponent(redirectPath);
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect };
      next(nextData);
    }
  });
}
